import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}routes/`;
//const baseUrl = "https://localhost:44356/api/routes/"; //process.env.API_URL + "/routes/"; 

export function getRoutes(searchCriteria) { //, bearer) {

    var url = baseUrl + "search";
    //var authHeader = "Bearer " + bearer; 

    return fetch(url, { method: "POST", body: JSON.stringify(searchCriteria), headers: { "content-type": "application/json" }, credentials: "include" })//, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function getRoute(id, bearer) {

    var url = baseUrl + id;
    //var authHeader = "Bearer " + bearer; 

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })//, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function saveRoute(route) {
    return fetch(baseUrl + (route.routeId || ""),
        {
            method: route.routeId ? "PUT" : "POST", 
            headers: { "content-type": "application/json" }, 
            body: JSON.stringify(route),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function addBookmark(route) {
    return fetch(`${ baseUrl }addbookmark/${ route.routeId }`,
        {
            method: "POST", 
            headers: { "content-type": "application/json" }, 
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function removeBookmark(route) {
    return fetch(`${ baseUrl }removebookmark/${ route.routeId }`,
        {
            method: "POST", 
            headers: { "content-type": "application/json" }, 
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function react(reaction) {
    return fetch(`${baseUrl}react`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(reaction),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function unReact(reaction) {
    return fetch(`${baseUrl}unreact`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(reaction),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function changeReaction(reaction) {
    return fetch(`${baseUrl}changereaction`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(reaction),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteRoute(routeId) {
    return fetch(baseUrl + routeId, { method: "DELETE" })
        .then(handleResponse)
        .catch(handleError);
}

export function searchRouteViewpoint(ne, sw, loadedRoutes) {
    var searchCriteria = { ne: ne, sw: sw, loadedRoutes: loadedRoutes }; 
    return fetch(`${baseUrl}searchrouteviewpoint/`, {
            method: "POST", 
            body: JSON.stringify(searchCriteria),
            headers: { "content-type": "application/json" }
        })
        .then(handleResponse)
        .catch(handleError);
}


export function shareRouteWithGroup(route, group) {
    var shareDetails = { groupId: group, routeId: route }; 
    return fetch(`${baseUrl}shareroute/`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(shareDetails),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function unShareRouteWithGroup(route, group) {
    var shareDetails = { group: group, route: route }; 
    return fetch(`${baseUrl}unshareroute/`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(shareDetails),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}




// WEBPACK FOOTER //
// ./src/api/routesApi.js